import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaBookOpen, FaHome } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { STORY_COVER_FALLBACKS } from '../config/imageFallbacks';
import '../styles/not-found.css';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const coverImages = STORY_COVER_FALLBACKS.slice(0, 3);

  return (
    <div className="not-found-page">
      <section className="not-found-section">
        <div className="container not-found-grid">
          <div className="not-found-copy">
            <p className="not-found-eyebrow">{t('notFoundPage.eyebrow')}</p>
            <h1>{t('notFoundPage.title')}</h1>
            <p>{t('notFoundPage.message')}</p>
            <div className="not-found-actions">
              <Link to="/create-story" className="not-found-primary">
                <FaBookOpen aria-hidden="true" />
                {t('notFoundPage.primaryCta')}
                <FaArrowRight aria-hidden="true" />
              </Link>
              <Link to="/" className="not-found-secondary">
                <FaHome aria-hidden="true" />
                {t('notFoundPage.homeCta')}
              </Link>
            </div>
          </div>

          <div className="not-found-visual" aria-hidden="true">
            {coverImages.map((cover, index) => (
              <img
                key={cover}
                src={cover}
                alt=""
                className={`not-found-cover not-found-cover-${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFoundPage;
